module.exports = __webpack_public_path__ + "e2.no2.ec94814b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/e2.no2.jpg
// module id = 4aCN
// module chunks = 0